"use client";

import React from "react";
import { Phone, Download } from "lucide-react";

interface DriverTelephonesDisplayProps {
  profiles: DriverTaxiProfile[];
}

const DriverTelephonesDisplay = ({
  profiles,
}: DriverTelephonesDisplayProps) => {
  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-200">
      <h2 className="text-lg sm:text-xl font-semibold mb-4">Vos numéros de téléphone</h2>
      <div className="border rounded-lg overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-[#f9fafb]">
            <tr>
              <th className="px-3 sm:px-4 py-3 text-left text-sm font-semibold text-gray-700">
                Numéro
              </th>
              <th className="px-3 sm:px-4 py-3 text-right text-sm font-semibold text-gray-700">
                Facture
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {profiles.length === 0 ? (
              <tr>
                <td colSpan={2} className="px-4 py-6 text-center text-sm text-gray-500">
                  Aucun numéro de téléphone trouvé
                </td>
              </tr>
            ) : (
              profiles.map((profile) => (
                <tr key={profile.phone_number}>
                  <td className="px-3 sm:px-4 py-3 text-sm text-gray-900">
                    <div className="flex items-center gap-2">
                      <Phone className="h-4 w-4 text-gray-500 shrink-0" />
                      <span className="break-all">{profile.phone_number}</span>
                    </div>
                  </td>
                  <td className="px-3 sm:px-4 py-3 text-right">
                    {profile.bill_url ? (
                      <a
                        href={profile.bill_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 sm:gap-2 ml-auto text-blue-600 hover:text-blue-800"
                      >
                        <Download className="h-4 w-4 shrink-0" />
                        <span>
                          Télécharger
                          <span className="hidden sm:inline"> les factures</span>
                        </span>
                      </a>
                    ) : (
                      <span className="text-sm text-gray-400">—</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DriverTelephonesDisplay;
